function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "tandempay_gradient_svg__a",
  x1: -0.206,
  y1: 1.331,
  x2: 0.511,
  y2: 0.13,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f3ffd0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f3ffd0",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "tandempay_gradient_svg__b",
  x1: 0.561,
  y1: 1,
  x2: 0.5,
  y2: 0.107,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#e7ffa0",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#e7ffa0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "tandempay_gradient_svg__c",
  x1: 0.561,
  y1: 1,
  x2: 0.5,
  y2: 0.107,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#c4ff12",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#c4ff12"
})));
var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "background gradient",
  opacity: 0.977
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1167"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 901",
  fill: "#a1dbd3",
  opacity: 0.407,
  d: "M222.754 1081.752l868.94-405.029 450.307 966.079-868.94 405.029z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1963",
  d: "M0 419.451L461.442 0l770.921 131.9-892.327 1142.873-321.1-47.4z",
  transform: "rotate(-44.98 1412.062 -44.897)",
  fill: "url(#tandempay_gradient_svg__a)"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1169",
  opacity: 0.54
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1960",
  d: "M38.824 0c208.8 0 1060.2 241.976 1060.2 450.775s-851.4 305.353-1060.2 305.353 492.631 468.361 492.631 259.562S-169.974 0 38.824 0z",
  transform: "rotate(65 403.11 1683.732)",
  fill: "url(#tandempay_gradient_svg__b)"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1959",
  d: "M366.317-198.852c113.3 0 132.78 326.982 132.78 440.285s-859.66 506.035-972.964 506.035S88.79 354.736 88.79 241.433s164.224-440.285 277.527-440.285z",
  transform: "rotate(-74.99 1504.367 -129.33)",
  fill: "url(#tandempay_gradient_svg__c)"
})));
var SvgTandempayGradient = function SvgTandempayGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2487.687,
    height: 2318.87
  }, props), _ref, _ref2);
};
export default SvgTandempayGradient;